import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

import { ProfileInfoCard, StatusBadge, ViewButton } from "@components";

import { ROUTES } from "@constants/routes";
import { TABS } from "@constants/tab-serial";

import { AprType } from "@type/HRM/aprs";

const {
  HRM: { EMPLOYEES },
} = ROUTES;

export const TableColumn = (t: TFunction<"translation", undefined>) => {
  return [
    {
      id: 1,
      name: t("APR_LIST.TABLE.COLUMN.NAME"),
      key: "nameBn",
      render: (_: any, row: AprType) => (
        <ProfileInfoCard employee={row.employee} />
      ),
    },
    {
      id: 2,
      key: "mark",
      name: t("APR_LIST.TABLE.COLUMN.APR_MARK"),
      render: (mark: string) => <Text color="subtitle1">{mark}</Text>,
    },
    {
      id: 3,
      key: "aprStatus",
      name: t("APR_LIST.TABLE.COLUMN.APR"),
      render: (aprStatus: string) => <StatusBadge status={aprStatus} />,
    },
    {
      id: 4,
      key: "kpiStatus",
      name: t("APR_LIST.TABLE.COLUMN.KPI"),
      render: (kpiStatus: string) => <StatusBadge status={kpiStatus} />,
    },

    {
      id: 5,
      key: "view",
      render: (_: number, row: AprType) => (
        <ViewButton link={`${EMPLOYEES}/${row.employeeID}?tab=${TABS.APR}`} />
      ),
    },
  ];
};
